<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listcompanies" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Add Instrument</span>
      </section>
    </article>
    <h4>Add Instrument</h4>
    <article class="row container">
      <h6 style="padding: 20px 0px 0px 0px;">
        Enter a ticker/exchange combination, then press "Search"
      </h6>
      <p style="padding: 0px 0px 30px 0px;">
        For a quick how-to video tutorial:
        <a href="https://fool.zoom.us/rec/share/tOhZNprdqV5Lc9L3zGTuZowHBZ78aaa81CUa-vcKyUy0jIYnQxlfrqzKduvaB9wO" target="_blank">
          <strong>watch this</strong>
        </a>
      </p>
      <section class="input-field col s5">
        <input type="text"
               placeholder="NasdaqGS"
               v-model="exchangeSymbol"
               @keyup.enter="tickerSymbol && exchangeSymbol ? fetchCapIQTradingItems(tickerSymbol, exchangeSymbol) : ''"
        >
        <label class="active">CapIQ Exchange Symbol</label>
      </section>
      <section class="input-field col s5">
        <input type="text" placeholder="DISC.A"
               v-model="tickerSymbol"
               @keyup.enter="tickerSymbol && exchangeSymbol ? fetchCapIQTradingItems(tickerSymbol, exchangeSymbol) : ''"
        >
        <label class="active">CapIQ Trading Item Ticker</label>
      </section>
      <section class="input-field col s2">
        <a class="waves-effect waves-light btn-small light-blue accent-4 "
           @click="fetchCapIQTradingItems(tickerSymbol, exchangeSymbol)"
           :disabled="!tickerSymbol || !exchangeSymbol"
        >
          Search
        </a>
      </section>
    </article>
    <div v-if="tradingItems.length">
      <article class="row container" v-for="tradingItem in tradingItems" :key="tradingItem.capiq_identifier">
        <section class="col s12">
          <article class="row">
            <section class="col s8">
              <h5 class="clickable" @click="selectCandidate(tradingItem)">
                <span class="new badge left amber accent-4" data-badge-caption="" v-if="tradingItem.capiq_identifier === candidate.capiq_identifier">Selected</span>
                <span class="new badge left grey lighten-1" data-badge-caption="" v-else>Please Select</span>
                Trading Item
              </h5>
              <table>
                <tbody>
                  <tr>
                    <th>CapIQ</th>
                    <td>{{ tradingItem.security.company.capiq_identifier }}</td>
                  </tr>
                  <tr>
                    <th>Name</th>
                    <td>{{ tradingItem.security.company.name }}</td>
                  </tr>
                  <tr>
                    <th>Industry</th>
                    <td>
                      <span v-if="tradingItem.security.company.industry.id">
                        {{ tradingItem.security.company.industry.name }}
                      </span>
                      <span v-else>
                        <span v-if="$auth.hasRoles('admin')">
                          <select class="browser-default" v-model="industryId">
                            <option :value="null" selected disabled>-- Choose an industry --</option>
                            <option v-for="industry in industries" :key="industry.id" :value="industry.id">
                              {{ industry.name }}
                            </option>
                          </select>
                        </span>
                        <span v-else class="red-text strong">
                          Unknown Industry: Please ask #investing-tech-help to add this trading item
                        </span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Country</th>
                    <td>{{ tradingItem.security.company.country.name }}</td>
                  </tr>
                  <tr>
                    <th>CapIQT</th>
                    <td>{{ tradingItem.capiq_identifier }}</td>
                  </tr>
                  <tr>
                    <th>Exchange</th>
                    <td>{{ tradingItem.exchange.name }} ({{ tradingItem.exchange.symbol }})</td>
                  </tr>
                  <tr>
                    <th>Ticker Symbol</th>
                    <td>{{ tradingItem.ticker_symbol }}</td>
                  </tr>
                  <tr>
                    <th>Type</th>
                    <td>{{ tradingItem.security.security_class }}</td>
                  </tr>
                  <tr>
                    <th>Primary</th>
                    <td>
                      <i class="fas fa-check-circle green-text" v-if="tradingItem.primary_flag && tradingItem.security.primary_flag" />
                      <i class="fas fa-times-circle red-text" v-else />
                    </td>
                  </tr>
                  <tr>
                    <th>Start Date</th>
                    <td>{{ tradingItem.security.security_start_date }}</td>
                  </tr>
                  <tr>
                    <th>End Date</th>
                    <td>{{ tradingItem.security.security_end_date || '-' }}</td>
                  </tr>
                  <tr>
                    <th>Active</th>
                    <td>
                      <i class="fas fa-check-circle green-text" v-if="tradingItem.active" />
                      <i class="fas fa-times-circle red-text" v-else />
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section class="col s4">
              <article class="row">
                <section class="col s12">
                  <h5>We Need Some More Info</h5>
                </section>
              </article>
              <article class="row">
                <section class="input-field col s12">
                  <input type="text" placeholder="Alphabet (C shares)" class="validate" v-model="candidate.display_name">
                  <label class="active blue-text">Display Name</label>
                </section>
              </article>
              <article class="row">
                <section class="input-field col s12">
                  <select class="browser-default"
                          v-model="candidate.security_class"
                          v-if="acceptableSecurityClasses.length"
                  >
                    <option v-for="securityClass of acceptableSecurityClasses" :key="securityClass.id" :value="securityClass">
                      {{ securityClass.name }}
                    </option>
                  </select>
                  <label class="active blue-text">
                    Security Class
                  </label>
                </section>
              </article>
              <article class="row">
                <section class="col s12">
                  <input class="btn waves-effect btn-small waves-light teal accent-4"
                         type="submit"
                         value="Save Instrument"
                         @click="submitTradingItem()"
                         :disabled="!candidate.capiq_identifier || !candidate.display_name || !candidate.security_class || waiting"
                  >
                </section>
              </article>
              <article class="row" v-show="waiting">
                <section class="col s1" />
                <section class="col s10 progress">
                  <aside class="indeterminate" />
                </section>
                <section class="col s1" />
              </article>
            </section>
          </article>
        </section>
      </article>
    </div>
    <div v-else>
      <article class="row container">
        <section class="col s12">
          <article class="row">
            <section class="col s12">
              <input class="modal-trigger btn waves-effect waves-light amber accent-4 left"
                    type="submit"
                    value="Manual Entry"
                    data-target="tickeradmin-add-instrument-manual-entry-modal"
              >
            </section>
          </article>
          <ul id="tickeradmin-add-instrument-exchange-reference" class="collapsible expandable">
            <li class="active">
              <div class="collapsible-header">
                <i class="fas fa-caret-down grey-text" />
                <span class="amber-text text-darken-1 strong" style="font-size: 1.1rem;">
                  Reference of Exchanges
                </span>
              </div>
              <div class="collapsible-body">
                <input type="text" placeholder="Search by name, symbol, or country..." v-model="exchangeSearchValue">
                <table>
                  <thead>
                    <tr>
                      <th>CapIQ Symbol</th>
                      <th>Quotes Symbol</th>
                      <th>Country</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="exchange in filteredExchanges" :key="exchange.id">
                      <th>{{ exchange.symbol }}</th>
                      <td>{{ exchange.quotes_symbol }}</td>
                      <td>{{ exchange.country.name }}</td>
                      <td>{{ exchange.name }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
           </ul>
        </section>
      </article>
    </div>
    <article id="tickeradmin-add-instrument-manual-entry-modal" class="modal">
      <section class="modal-content">
        <article class="row">
          <section class="col s12">
            <h4>Manual Security Request</h4>
            <h5 style="padding-bottom: 10px;">Counldn't find the security in Xpressfeed?</h5>
          </section>
        </article>
        <article class="row">
          <section class="input-field col s6">
            <input type="text" v-model="manualEntry.exchange">
            <label class="active unclickable">
              Exchange
            </label>
          </section>
          <section class="input-field col s6">
            <input type="text" v-model="manualEntry.ticker">
            <label class="active unclickable">
              Ticker
            </label>
          </section>
        </article>
        <article class="row">
          <section class="input-field col s12">
            <input type="text" v-model="manualEntry.name">
            <label class="active unclickable">
              Name
            </label>
          </section>
        </article>
        <article class="row">
          <section class="input-field col s12">
            <textarea class="materialize-textarea" v-model="manualEntry.reason" />
            <label class="active unclickable">
              Reason
              <i class="far fa-question-circle light-blue-text" />
            </label>
          </section>
        </article>
      </section>
      <section class="modal-footer">
        <button class="modal-close btn grey darken-1 lighten-1 waves-effect waves-light left">
          Cancel
        </button>
        <button class="modal-close btn teal accent-4 waves-effect waves-light"
                @click="createManualEnty"
                :disabled="!manualEntry.ticker || !manualEntry.exchange || !manualEntry.name || !manualEntry.reason"
        >
          Submit
        </button>
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

const defaultPayload = {
  display_name: '',
  security_class_id: 0,
};

export default {
  name: 'TickerAdminAddInstrument',
  components: {},
  props: {},
  data() {
    return {
      exchangeSearchValue: '',
      tickerSymbol: '',
      exchangeSymbol: '',
      tradingItems: [],
      candidate: { ...defaultPayload },
      exchanges: [],
      securityClasses: [],
      manualEntry: {
        ticker: '',
        exchange: '',
        name: '',
        reason: '',
      },
      waiting: false,
      environment: 'production',
      industries: [],
      industryId: null,
    };
  },
  computed: {
    acceptableSecurityClasses() {
      return this.securityClasses.filter(obj => obj.name === 'stock' || obj.name === 'etf' || obj.name === 'mutual-fund');
    },
    filteredExchanges() {
      const searchValue = this.exchangeSearchValue.toLowerCase();
      if (!searchValue) {
        return this.exchanges;
      };
      return this.exchanges.filter(exchange => {
        const { symbol, quotes_symbol, name, country } = getNormalizeExchangeInputs(exchange);
        return searchExchangeForMatches(searchValue, symbol, quotes_symbol, name, country);

        function getNormalizeExchangeInputs(exchange) {
          let {symbol, quotes_symbol, name, country } = exchange;
          symbol = symbol ? symbol.toLowerCase() : '';
          quotes_symbol = quotes_symbol ? quotes_symbol.toLowerCase() : '';
          name = name ? name.toLowerCase() : '';
          country = country.name ? country.name.toLowerCase() : '';
          return { symbol, quotes_symbol, name, country };
        }

        function searchExchangeForMatches(searchValue, symbol, quotesSymbol, name, countryName) {
          const symbolMatched = symbol.includes(searchValue);
          const quotesSymbolMatched = quotesSymbol.includes(searchValue);
          const nameMatched = name.includes(searchValue);
          const countryMatched = countryName.includes(searchValue);
          return symbolMatched || quotesSymbolMatched || nameMatched || countryMatched;
        }
      });
    },
  },
  watch: {},
  methods: {
    async fetchCapIQTradingItems(symbol, exchange) {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/capiq/trading_items/?symbol=${symbol}&exchange=${exchange}`);
      this.tradingItems = data;
      this.candidate = { ...defaultPayload };
      if (data.length === 1) {
        this.selectCandidate(data[0]);
      }
      if (!data.length) {
        this.toast('No results found', 'orange');
      }
    },
    selectCandidate(tradingItem) {
      this.candidate = { ...this.candidate, ...tradingItem };
      this.candidate.display_name = tradingItem.security.company.name;
    },
    initModal() {
      this.materialize.Modal.init(document.getElementById('tickeradmin-add-instrument-manual-entry-modal'), {
        dismissible: false,
        preventScrolling: false,
      });
    },
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/exchanges/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/security_classes/`),
      ];
      const [exchangesResp, securityClassesResp] = await Promise.all(promises);
      [this.exchanges, this.securityClasses] = [exchangesResp.data.sort((a, b) => a.symbol.toLowerCase().localeCompare( b.symbol.toLowerCase())) , securityClassesResp.data];
      this.initCollapsible();
    },
    initCollapsible() {
      this.materialize.Collapsible.init(document.getElementById('tickeradmin-add-instrument-exchange-reference'), {
        accordion: false,
      });
    },
    createManualEnty() {
      this.ping(window.env.SLACK_HELP_CHANNEL, `
A *Manual Entry* was requested to add a security to Fool IQ:
>*Analyst*: *<mailto:${this.$auth.user.email}|${this.$auth.user.name}>*
>*Exchange*: ${this.manualEntry.exchange}
>*Ticker*: ${this.manualEntry.ticker}
>*Name*: ${this.manualEntry.name}
>*Reason*: ${this.manualEntry.reason}\n\n
Please advise this analyst.
      `);
      this.toast("Ok, we've submit the request to Fool IQ", 'green');
    },
    async submitTradingItem() {
      if (!this.candidate.active) {
        this.toast('Warning: The security you are adding is inactive', 'amber');
      }
      if (!this.candidate.display_name) {
        return this.toast('Please enter a Display Name', 'pink');
      }
      if (!this.candidate.security_class) {
        return this.toast('Please choose a Security Class', 'pink');
      }
      if (!this.$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')) {
        return this.toast('Only certain portfolio/product managers can add new tickers right now. Please ping #investing-tech-help and they will handle your request!', 'pink');
      }
      try {
        await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/parent/by_capiq_id/${this.candidate.capiq_identifier}/`);
        return this.toast('Security already exists in Fool IQ', 'pink');
      } catch (err) {
        if (err.response.status === 404) {
          this.saveInstrument();
        }
      }
    },
    async saveInstrument() {
      const payload = {
        analyst_id: this.$auth.user.pk,
        capiq_identifier: this.candidate.capiq_identifier,
        display_name: this.candidate.display_name,
        security_class_id: this.candidate.security_class.id,
      };
      if (this.industryId) {
        payload.industry_id = this.industryId;
      } else if (!this.candidate.security.company.industry.id) {
        return this.notifyMissingIndustry();
      }
      this.waiting = true;

      try {
        let response;
        let viewPath;
        if (this.candidate.security_class.name === 'mutual-fund') {
          response = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/mutual_fund/`, payload);
          viewPath = '/tickeradmin/viewmutualfund';
        } else {
          response = await axios.post(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/equity/`, payload);
          viewPath = '/tickeradmin/viewequity';
        }
        this.waiting = false;

        const instrument = response.data;
        const displaySymbol = instrument.exchange ? `${instrument.exchange}:${instrument.symbol}` : instrument.symbol;
        this.toastWithLink(
          `Created ${instrument.asset_class}: ${displaySymbol} - ${instrument.name} (Instrument ID: ${instrument.id})`,
          'View Details',
          `${viewPath}?instrument_id=${instrument.id}`,
          'green'
        );

        this.tradingItems = [];
        this.candidate = { ...defaultPayload };
        this.tickerSymbol = '';
        this.exchangeSymbol = '';
        this.industryId = null;
      } catch (error) {
        this.waiting = false;
        this.toast('Failed to create instrument. Please contact #investing-tech-help.', 'pink');
      }
    },
    async fetchIndustries() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/industries/`);
      this.industries = this.sortArray(data, 'name');
    },
    notifyMissingIndustry() {
      this.ping(window.env.SLACK_HELP_CHANNEL, `
A trading item with a *Missing Industry* was requested to be added to the USM:
>*Analyst*: *<mailto:${this.$auth.user.email}|${this.$auth.user.name}>*
>*Trading Item ID*: ${this.candidate.capiq_identifier}
>*Fully Qualified Ticker*: ${this.candidate.exchange.symbol}:${this.candidate.ticker_symbol}
>*Name*: ${this.candidate.security.company.name}\n\n
Please manually override the industry for this.
      `);
      this.toast("This trading item has an unknown industry. We've pinged Investing Tech to look into this.", 'amber');
    },
  },
  mounted() {
    this.initModal();
    this.fetchMetadata();
    this.fetchIndustries();
    this.environment = window.env.ENVIRONMENT;
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';


</style>
